import React from "react"
import {FieldViewProps} from "../../../render/view"
import Votes from "../../../../model2/voting/votes"
import {ALL_REACTIONS} from "../../../../model2/reaction/const"
import EmojiSymbolDeprecated from "../../../../gd-components/icons/common/emoji/emoji-symbol";

// used in board

export default function FieldVoting_ViewProperty(props: FieldViewProps) {


    const value = props.field.getViewValue(props.model)

    const votes : Votes = Votes.initFromJson(value)

    // @ts-ignore
    const voteIcon : any = ALL_REACTIONS[props.field.voteIcon]

    if (votes.isEmpty) return null

    const reactionClass = Classes('reaction-view disabled size-22',{
        'my-reaction'   : votes.hasAlreadyVoted
    })

    const classes = Classes('ui5-reactions', props.className)

    return (
        <div className={classes}>
            <div className={reactionClass}>
                <div className="reaction-emoji">
                    <EmojiSymbolDeprecated symbol={voteIcon} size="15" />
                </div>
                <div className="reaction-count">{votes.total}</div>
            </div>
        </div>
    )

}